module.exports = __webpack_public_path__ + "img/illustration-home-goal.825721ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustration-home-goal.png
// module id = Funl
// module chunks = 0